import React, { useEffect, useState, useContext } from 'react';
import { TextField, Button, Grid, ListItemIcon, ListItemText, Typography, FormControl
	, InputLabel, Select, Accordion, AccordionSummary, AccordionDetails, Tooltip
	, Input, List, ListItem, ListItemAvatar, Avatar, ListItemSecondaryAction 
	, FormHelperText
} from '@material-ui/core/';

import FolderIcon from '@material-ui/icons/Folder';
import RemIcon from '@material-ui/icons/Description';
import DeleteIcon from '@material-ui/icons/Delete';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import LabelImportantIcon from '@material-ui/icons/LabelImportant';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import PostAddIcon from '@material-ui/icons/PostAdd';
import ListAltIcon from '@material-ui/icons/ListAlt';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import Divider from '@material-ui/core/Divider';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { InputAdornment,OutlinedInput } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';

import { useParams, Redirect } from 'react-router-dom';
import Content from '../components/Content';
import { validateVal } from 'utils/helpers';
import { sendGetRequest, sendPostRequest, sendPutRequest, sendDownloadRequest } from 'utils/api';

import { formPropTypes, formDefaultPropValues } from 'proptypes/index';
import Blocker from 'components/Blocker';
import { ErrorAlert } from 'components/Alerts';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useHistory } from 'react-router-dom';
import ChevronRightTwoToneIcon from '@material-ui/icons/ChevronRightTwoTone';
import { DataGrid, useGridControlState } from '@material-ui/data-grid';
import LaunchOutlinedIcon from '@material-ui/icons/LaunchOutlined';

import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SaveIcon from '@material-ui/icons/Save';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import PickList from './forms/formElements/PickList';
import SimplePickList from './forms/formElements/SimplePickList';
import PickListV2 from './forms/formElements/PickListV2';

import headerImage from 'assets/file_upload.png';
import headerRoute from 'assets/route.png';
import { UserContext } from '../contexts';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { genKey } from '../utils/helpers';
import _ from 'lodash';
import { isFriday } from 'date-fns';

const useStyles = makeStyles({
	card: {
	  minWidth: 275,
	},
	bullet: {
	  display: 'inline-block',
	  margin: '0 2px',
	  transform: 'scale(0.8)',
	},
	title: {
	  fontSize: 14,
	},
	pos: {
	  marginBottom: 12,
	},
	accordion:{
		background:'#F8F8F8'
	},
	icon:{
		color:'blue',
		cursor:'pointer',
	},
	link:{
		color:'blue',
		cursor:'pointer',
		textDecoration: 'underline',
	}
  });


const options = [
	'Create',
	'Search',
	'Attachments',
	'Edit', 
	'Delete',
	'Back'
  ];
  
const ITEM_HEIGHT = 50;

const table = 'famas/header';

const blank = {
	idMaster: 0,
	businessUnit: '',
	docType: 'System',
	docNo: 'NEW',
	docCreateDate: new Date(),
    fromUser: 1,
	fromUserName: '',
	toUser: 0,
	toUserName: '',
	department: 0,
	plantSite: '',
	buildingStructure: '',
	room: '',
	action: '',
	lines: [],
};

const validateForm = (key, value) => {
	const errors = {};
	switch (key) {
		case 'toUserName':
			errors.toUserName = validateVal({
				value: value,
				required: true,
				maxLength: 100,
			});
			break;
		case 'department':
			errors.department = validateVal({
				value: value,
				maxLength: 500,
				required: true,
			});
			break;
		case 'businessUnit':
			errors.businessUnit = validateVal({
				value: value,
				maxLength: 30,
				required: true,
			});
			break;
		
		case 'action':
			errors.action = validateVal({
				value: value,
				maxLength: 30,
				required: true,
			});

			break;
		
		case 'docCreateDate':
			errors.action = validateVal({
				value: value,
				maxLength: 30,
				required: true,
			});

			break;
		
		default:
			break;
	}
	return errors;
};

const validateFormValues = (values) => {

	let errors = [];
	Object.keys(values).forEach((key) => {
		errors = { ...errors, ...validateForm(key, values[key]) };
	});
	return errors;
};

const actions = {create: 'create', edit: 'edit', delete: 'delete', close:'close', search:'search'}

const FamasForm = (props) => {
	const context = useContext(UserContext);
	
	const classes = useStyles();
	const params = useParams();
	const history = useHistory();
	const { closeModal } = props;
	
	const [recordId, setRecorId] = useState('');
	const [formValues, setFormValues] = useState({});
	const [formErrors, setFormErrors] = useState({});
	const [requesting, setRequesting] = useState(false);
	const [disabledSelect, setDisabledSelect] = useState(true);
	const [selectValue, setSelectValue] = useState('None');
	const [success, setSuccess] = useState(null);
	const [status, setStatus] = useState(null);
	const [action, setAction] = useState('');
	const [rows, setRows] = useState([]);
	const [selectedRow, setSelectedRow] = useState({});
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [locations, setLocations] = useState([]);
	const [departments, setDepartments] = useState([]);
	const [plantSite, setPlantSite] = useState([]);
	const [buildingStructure, setBuildingStructure] = useState([]);
	const [room, setRoom] = useState([]);
	const [disabledForm, setDisabledForm] = useState(true);
	const [businessUnit, setBusinessUnit] = useState([]);
	const open = Boolean(anchorEl);
	const [openDialog, setOpenDialog] = useState(false);
	const [capturedNames, setCapturedNames] = useState([]);
	const [openDialogUpload, setOpenDialogUpload] = useState(false);
	const [fileUploads, setFileUploads] = useState([]);
	const [remarks, setRemarks] = useState([]);
	const [openDialogRoute, setOpenDialogRoute] = useState(false);
	const [openReceiverDialog, setOpenReceiverDialog] = useState(false);
	const [buttonLabel, setButtonLabel] = useState("approver");
	const [buItems, setBuItems] = useState([]);
	const [footerDetails, setFooterDetails] = useState({});
	const [receiverAction, setReceiverAction] = useState([]);
	const [requireAcknowledgement, setRequireAcknowledgement] = useState(false);
	const [genericRemarks, setGenericRemarks] = useState('');
	const [tls, setTls] = useState([]);
	const [selectedTl, setSelectedTl] = useState({});
	const [deletedRows, setDeletedRows] = useState([]);
	const [total, setTotal] = useState(0);
	const openAsset = (p_row) =>{
	
		setSelectedRow(p_row);
		setOpenDialog(true);
	
	}

	const deleteAsset = (p_row) =>{
		if(action === 'edit' || action === 'create'){
			let r = window.confirm("Are you sure you want to remove the asset from your list?");
			if (r === true) {
				const tempRows = JSON.parse(JSON.stringify(rows));	
				const newRows = [];
				const delRows = JSON.parse(JSON.stringify(rows));

				tempRows.forEach(item => {
					if (item.assetCode !== p_row.assetCode) {
						newRows.push(item);
					} else {
						delRows.push(item);
					}

				})
				setDeletedRows(delRows);
				setRows(newRows);
			} 
		}
	}

	const columns = [
		{
			field: 'quantity',
			headerName: 'Qty',
			type: 'number',
			
			editable: false,
			minWidth: 50
		},

		{
			field: 'serialNo',
			headerName: 'Serial No',
			minWidth: 150,
			editable: false,
		},
		{
			field: 'assetCode',
			headerName: 'Asset Code',
			
			minWidth: 250,
			editable: false,
		},
		{
			field: 'category',
			headerName: 'Category',
			minWidth: 50,
			editable: false,
		},
		{
			field: 'assetDesc',
			headerName: 'Description',
			minWidth: 300,
			editable: false,
			renderCell: (params) => {
				return <Tooltip title={params.value} aria-label="add">
				  			<Typography component="span" className={classes.link} onClick={()=> openAsset(params.row)}>{params.value}</Typography>
			  			</Tooltip>
			 
			}
		},
		{
			field: 'acqCost',
			headerName: 'Acq. Cost',
			type: 'number',
			minWidth: 200,
			editable: false,
		},
		{
			field: 'totalPrice',
			type: 'number',
			headerName: 'Total Price',
			minWidth: 250,
			editable: false,
		},
		{
			field: 'status',
			
			headerName: 'Status',
			minWidth: 150,
			editable: false,
		},

		{
			field: 'idMaster',
			headerName: '',
			width: 60,
			renderCell: (params) => {
				return <LaunchOutlinedIcon onClick = {()=>openAsset(params.row)} className={classes.icon}/>
			}			
		},
		{
			field: 'lineIdMaster',
			headerName: '',
			width: 60,
			renderCell: (params) => {
				return <DeleteForeverIcon onClick = {()=>deleteAsset(params.row)} className={classes.icon}/>
			}			
		},
		{
			field: 'masterListId',
			
			headerName: 'Master List ID',
			minWidth: 150,
			editable: false,
		},
	];
	
	const columnsEmployees = [
		
		{
		  field: 'lastName',
		  headerName: 'Last name',
		  width: 150,
		  editable: false,
		  sortable: true,
		},
		{
		  field: 'firstName',
		  headerName: 'First name',
		  width: 150,
		  editable: false,
		  sortable: true,
		},
		{
			field: 'company',
			headerName: 'Company',
			width: 150,
			editable: false,
			sortable: true,
		},
		{
			field: 'department',
			headerName: 'Department',
			width: 150,
			editable: false,
			sortable: true,
		},

		{ field: 'empId', headerName: 'ID', width: 150 }
	  ];

	const personGroupColumns = [
		{ field: 'id', headerName: 'ID', width: 150 },
		{
		  field: 'fullName',
		  headerName: 'Full Name',
		  width: 150,
		  editable: false,
		  sortable: true,
		}
	  ];

	const columnsSearchFamasItems = [
		
		{
		  field: 'assetTag',
		  headerName: 'Asset Tag',
		  width: 150,
		  editable: false,
		  sortable: true,
		},
		{
		  field: 'assetDesc',
		  headerName: 'Asset Description',
		  width: 150,
		  editable: false,
		  sortable: true,
		},
		{
		  field: 'uom',
		  headerName: 'UOM',
		  width: 150,
		  editable: false,
		  sortable: true,
		},
		{
		  field: 'serialNo',
		  headerName: 'Serial Number',
		  width: 150,
		  editable: false,
		  sortable: true,
		},
		{
			field: 'quantity',
			headerName: 'Quantity',
			width: 150,
			editable: false,
			sortable: true,
		},
		{
			field: 'acqCost',
			headerName: 'Acquisition Cost',
			width: 150,
			editable: false,
			sortable: true,
		},
		{
			field: 'masterListId',
			headerName: 'Master List ID',
			width: 150,
			editable: false,
			sortable: true,
		},
		{
			field: 'businessUnit',
			headerName: 'Business Unit',
			width: 150,
			editable: false,
			sortable: true,
		},
		{
			field: 'toUserNames',
			headerName: 'Assignee',
			width: 150,
			editable: false,
			sortable: true,
		},
		{ field: 'to_user', headerName: 'To User ID', width: 150 }

		
	  ];
	
	const columnsUnassignedAssets = [
		{ 	
			field: 'idMaster', 
			headerName: 'ID', 
			width: 150, 
			editable: false,
		  	sortable: true,
		},
		{
		  field: 'assetTag',
		  headerName: 'Asset Tag',
		  width: 150,
		  editable: false,
		  sortable: true,
		},
		{
		  field: 'assetDesc',
		  headerName: 'Asset Description',
		  width: 150,
		  editable: false,
		  sortable: true,
		},
		{
		  field: 'uom',
		  headerName: 'UOM',
		  width: 150,
		  editable: false,
		  sortable: true,
		},
		{
		  field: 'serialNo',
		  headerName: 'Serial Number',
		  width: 150,
		  editable: false,
		  sortable: true,
		},
		{
			field: 'quantity',
			headerName: 'Quantity',
			width: 150,
			editable: false,
			sortable: true,
		},
		{
			field: 'acqCost',
			headerName: 'Acquisition Cost',
			width: 150,
			editable: false,
			sortable: true,
		},
		{
			field: 'businessUnit',
			headerName: 'Business Unit',
			width: 150,
			editable: false,
			sortable: true,
		}
		
	  ];
	const handleChange = (event) => {
		
		console.log('HANDLE CHANGE', event.target.name, ' : ' ,event.target.value);

		
			setFormValues({ ...formValues, [event.target.name]: event.target.value });
		
		
		setFormErrors({
			...formErrors,
			...validateForm(event.target.name, event.target.value),
		});
	};

	
	const getTempCode = async (theBu) =>{
		if(theBu){
			const tempData = await sendGetRequest(`/${table}/tempcode/${theBu}`);
			if(tempData.data){
				for(const item of tempData.data){
				setFormValues({...formValues, businessUnit: theBu,
											  docNo:item.tempCode, fromUserName:item.empName, 
											  fromUser:item.idMaster,
											  docType: 'System',
											  docCreateDate: new Date(),
											  idMaster: 0,
											  action: '',
											  lines: [],
							}); 
				console.log(tempData.data);	
			}
		  }
		}
  	}

    const handleChangeBU = (event) => {
			getTempCode(event.target.value)
			console.log(event.target.value)

		setFormErrors({
			...formErrors,
			...validateForm(event.target.name, event.target.value),
		});
	};


	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleChangeAction = (e) => {
		setFormValues({...formValues, action: e.target.value});
		setSelectValue(e.target.value);
	};

	useEffect(()=>{
		if(action === 'create'){
			setFormValues({...formValues, ...blank});
			getTempCode();
		}
	},[action])

	useEffect(()=>{
		console.log(formErrors);
	},[formErrors])

	useEffect( async () => {
		
		setFormErrors(validateFormValues(formValues));
		if(params.id){
			setRecorId(params.id);
		}
		let buItems = JSON.parse(localStorage.getItem('businessUnits'));
		setBuItems(buItems);
		
		console.log("BUSINESS UNITS IN FAMAS FORM", buItems);

		const path = `/misc?config_type=location`;
		setRequesting(true);
		sendGetRequest(path).then((res) => {
			const tempLocations = [];

			setRequesting(false);
			if (res.error) {
				setSuccess(false);
				setStatus(res.error.message);
				return;
			}
			for(const locations of res.data){
				tempLocations.push({id: locations.idMaster, location: locations.configName})
			}
			setLocations(tempLocations);
		});

		let deptStore = JSON.parse(localStorage.getItem('depts'));
		setDepartments(deptStore);
        
		// const pathDepts = `/depts`;
		// setRequesting(true);
		// sendGetRequest(pathDepts).then((res) => {
		// 	console.log(res.data);
		// 	const departments = [];

		// 	setRequesting(false);
		// 	if (res.error) {
		// 		setSuccess(false);
		// 		setStatus(res.error.message);
		// 		return;
		// 	}
		// 	for(const department of res.data){
		// 		departments.push({id: department.idMaster, department: department.deptName})
		// 	}
		// 	setDepartments(departments);
		// });

		let plantSiteStore = JSON.parse(localStorage.getItem('plantSite'));
		setPlantSite(plantSiteStore);
		// const pathPlantSite = `/misc?config_type=PlantSite`;
		// setRequesting(true);
		// sendGetRequest(pathPlantSite).then((res) => {
			
		// 	const items = [];

		// 	setRequesting(false);
		// 	if (res.error) {
		// 		setSuccess(false);
		// 		setStatus(res.error.message);
		// 		return;
		// 	}
		// 	for(const item of res.data){
		// 		items.push({id: item.idMaster, value: item.configName})
		// 	}
		// 	setPlantSite(items);
		// });

		let buildingStructureStore = JSON.parse(localStorage.getItem('buildingStructure'));
		setBuildingStructure(buildingStructureStore);
		// const pathBuildingStructure = `/misc?config_type=BuildingStructure`;
		// setRequesting(true);
		// sendGetRequest(pathBuildingStructure).then((res) => {
		// 	console.log(res.data);
		// 	const items = [];

		// 	setRequesting(false);
		// 	if (res.error) {
		// 		setSuccess(false);
		// 		setStatus(res.error.message);
		// 		return;
		// 	}
		// 	for(const item of res.data){
		// 		items.push({id: item.idMaster, value: item.configName})
		// 	}
		// 	setBuildingStructure(items);
		// });

		let roomStore = JSON.parse(localStorage.getItem('room'));
		setRoom(roomStore);
		// const pathRoom = `/misc?config_type=Room`;
		// setRequesting(true);
		// sendGetRequest(pathRoom).then((res) => {
		// 	console.log(res.data);
		// 	const items = [];

		// 	setRequesting(false);
		// 	if (res.error) {
		// 		setSuccess(false);
		// 		setStatus(res.error.message);
		// 		return;
		// 	}
		// 	for(const item of res.data){
		// 		items.push({id: item.idMaster, value: item.configName})
		// 	}
		// 	setRoom(items);
		// });

		const pathBusinessUnit = `/company`;
		setRequesting(true);
		sendGetRequest(pathBusinessUnit).then((res) => {
			console.log(res.data);
			const items = [];

			setRequesting(false);
			if (res.error) {
				setSuccess(false);
				setStatus(res.error.message);
				return;
			}
			for(const item of res.data){
				items.push({id: item.companyName, value: item.companyName})
			}
			setBusinessUnit(items);
		});

		if(parseInt(params.id)){

			const pathFamas = `/famas/header/${params.id}`;

			setRequesting(true);
			sendGetRequest(pathFamas).then((res) => {
				setRequesting(false);
				if (res.error) {
					setSuccess(false);
					setStatus(res.error.message);
					return;
				}
			
				const rowItems = [];

				for(const item of res.data){
					rowItems.push({
						lineIdMaster: item.lineIdMaster
						, quantity: item.quantity
						, acqCost: item.acqCost
						, assetTag: item.assetTag
						, assetDesc: item.assetDesc
						, totalPrice: (item.quantity || 1) * item.acqCost
						, status: item.status
						, serialNo: item.serialNo
						, masterListId: item.masterListId
					})
				}

				let userName = res.data[0].toUserName;
				if(isJson(res.data[0].toUser)===true){
					userName = 'Multiple Owners';
				}
					

				setFormValues({...formValues
					, idMaster: res.data[0].idMaster
					, businessUnit: res.data[0].businessUnit
					, docType: res.data[0].docType
					, docNo: res.data[0].docNo
					, docCreateDate: res.data[0].docCreateDate
					, fromUser: res.data[0].fromUser
					, fromUserName: res.data[0].fromUserName
					, toUser: res.data[0].toUser
					, toUserName: userName
					, department: res.data[0].department
					, plantSite: res.data[0].plantSite
					, buildingStructure: res.data[0].buildingStructure
					, room: res.data[0].room
					, action: res.data[0].action
					, initApprv: res.data[0].initApprv
					, approvalStatus: res.data[0].approvalStatus
					, deptName: res.data[0].deptName
				});
				
				
				
				
				if(rowItems.length > 0){
					setValueAssets(rowItems);
				}
				
			});
		}else{
 
			if(params.id === 'create'){
				//history.push('/famas/create');
				setFormValues({});
				setDisabledForm(false);
				setAction(actions.create);
				setRows([]);
			}
 
		}
	}, []);

	const isJson = (p_string) =>{
        try{
			if(parseInt(p_string))return false;

            JSON.parse(p_string);
            return true;
        }catch{
            return false;
        }
    }

	useEffect(async ()=>{
		const getNames = async () =>{
			if(parseInt(params.id)){
				const getForReceiving = `/famas/header/forreceiving/${params.id}`
				sendGetRequest(getForReceiving).then((res)=>{
					if(res.data){
						setReceiverAction(res.data);
					}
				});
			}
		}
		await getNames();
	},[formValues.idMaster]);

	useEffect(()=>{

		let total = rows.reduce((total, item)=>total + item.totalPrice || 0,0)
		setTotal(total);

	},[rows])

	useEffect( async()=>{
		console.log("footer set");
		console.log(footerDetails);

		if(footerDetails.approval_status){
			if(footerDetails.approver && footerDetails.approval_status.toString().toLowerCase() === 'for tl approval'){
				console.log("footer set to : FOR TL APPROVAL");
				setButtonLabel("approve");
			}
			
			if(footerDetails.editable && footerDetails.approval_status.toString().toLowerCase() === 'for approval'){
				console.log("footer set to: ROUTE FOR APPROVAL");
				setButtonLabel("route for approval");
			}
		}
		
	},[footerDetails]);

	useEffect( async()=>{
		console.log("FAMAS FORM", formValues);
		console.log("CONTEXT", context.userInfo);
		// let v_editable = false;

		// if(formValues.fromUser.toString() === context.userInfo.empIdMaster.toString()){
		// 	v_editable = true;
		// }
		// if(formValues.fromUserName.toString() === context.user.toString()){
		// 	v_editable = true;
		// }


		if(context.userInfo.empIdMaster && formValues.idMaster){
			setFooterDetails({
				from: formValues.fromUserName
				, tl_approver:  formValues.initApprv
				, department:  formValues.deptName
				, to: formValues.toUserNames
				, approval_status: formValues.approvalStatus
				, editable: formValues.fromUser.toString() === context.userInfo.empIdMaster.toString()
				, approver: formValues.initApprv || '' === context.userInfo.user.toString() && formValues.approvalStatus === 'For TL Approval'
			});
		}
		
	},[formValues, context.userInfo]);

	const onSubmit = (e) => {
		let validation = validateFormValues(formValues);
		setFormErrors({...formErrors, ...validation});
		let raiseError = false;

		Object.entries(validation).forEach(entry => {
			const [key, value] = entry;
			if(!_.isEmpty(value)){
				console.log(key, value);
				raiseError = true;		
				// setFormErrors({
				// 	...formErrors,
				// 	[key]: value
				// });
			}
		});
		if(raiseError){
			setSuccess(false);
			setStatus("Please provide value(s) for all the required items ");
			return;
		}
		
		

		e.preventDefault();

		if(rows.length === 0){
			
			setSuccess(false);
			setStatus("Please add at least 1 Asset item in the table.");
			setRows([]);
			return;
		}

		setRequesting(true);
		
		const postData = {
			idMaster: formValues.idMaster
			, businessUnit: formValues.businessUnit
			, docType: formValues.docType
			, docNo: formValues.docNo
			, docCreateDate:formValues.docCreateDate
			, fromUser: formValues.fromUser 
			, fromUserName: formValues.fromUserName || ''
			, toUser: formValues.toUser
			, toUserName: formValues.toUserName
			, department: formValues.department
			, plantSite: formValues.plantSite
			, buildingStructure: formValues.buildingStructure
			, room: formValues.room
			, action: formValues.action
			, groupName: formValues.groupName || ''
			, lines: rows
			
		}

		sendPostRequest(`/${table}/all`, postData).then((res) => {
				setRequesting(false);
				if (res.error) {
					setSuccess(false);
					let msg = res.error.response.data.message ? JSON.stringify(res.error.response.data.message) : JSON.stringify(res.error.message);
					setStatus(msg);
					alert(msg);
					return;
				}
				
				setSuccess(true);
				setStatus(null);
				setFormValues({ ...formValues, idMaster: res.data[0].idMaster, approvalStatus: res.data[0].approvalStatus });
				alert("FAMAS DOC saved successfully");

				setAction('');
				setDisabledForm(true);
				setFormErrors({});
				//closeModal ? closeModal(res.data[0].idMaster) : setSuccess(true);
		});

		
	};
	

	const handleClose = (e, p) => {
		
		switch(p){
			case 'Create':
				history.push('/famas/create');
				setFormValues({});
				setDisabledForm(false);
				setAction(actions.create);
				setRows([]);
				break;
			
			case 'Edit':
				if(footerDetails.editable === false){
					alert("Sorry. You are not allowed to EDIT this document.")
					return;
				}
				
				if(footerDetails.approval_status === 'Approved'){
					alert("Sorry. You are not allowed to EDIT document(s) with STATUS: 'FOR TL APPROVAL'")
					return;
				}

				if(!formValues.idMaster) return;
				setDisabledForm(false);
				setAction(actions.edit);
				break;

			case 'Attachments':
				if(formValues.idMaster){
					setOpenDialogUpload(true);	
					getUploadItems();
				}
				break;
			case 'Search':
				setAction('');
				history.goBack();
				break;		
			
			case 'Delete':
				if(!formValues.idMaster) return;
				setAction(actions.delete);
				break;	

			case 'Back':
				history.goBack();
				break;
			default:
				console.log(e);
		}
		
		setAnchorEl(null);
	};

	const handleCloseDialog = (e) => {
		const tempRows = JSON.parse(JSON.stringify(rows));
		console.log(tempRows);
		console.log(e);

		const newRows = [];

		if(e==='update'){	
			
			tempRows.forEach(item => {
				if (item.assetCode === selectedRow.assetCode) {
					item.quantity = selectedRow.quantity;
					item.totalPrice = selectedRow.acqCost * selectedRow.quantity;
				} 
				newRows.push(item);
			})
	
			setRows(newRows);
		}
		if(e==='remove'){
			tempRows.forEach(item => {
		
				if (item.assetCode !== selectedRow.assetCode) {
					newRows.push(item);
				} 
			})
	
			setRows(newRows);
		}
		setOpenDialog(false);
	}

	const handleRowSelection = (e) => {
    
		const selectedItems = [];
		 
		if(e.length>0){
			for(const item of e){
				let selected = rows.filter(row => row.id === item);

				selectedItems.push(selected);
			}
			
			setDisabledSelect(false);
		}else{
			setDisabledSelect(true);
			setSelectValue('None');
		}
	
		//setSelection(selectedItems);
	}

	const handleDateChange = (e) =>{
		//if(inputDisabled)return;
		setFormValues({...formValues, docCreateDate: e})

	}

	const setValue = async (p_record, p_type, p_group = null) =>{
		console.log("RECORD VALUE", p_record, p_type);
		if(p_record){
			if(p_record.length === 0)return;
		}else{
			return;
		}

		if( p_type === 'Person' ){
			const tempItems = [];
			let ctr = 0;
			
			for(const item of p_record){
				ctr++;
				tempItems.push({toUser: item.empId})
			}
			if(ctr > 1){
				setFormValues({...formValues, toUser: JSON.stringify(tempItems), toUserName: 'Multiple Owners' })
			}else{

				let dept_id = 0;

				for(const item of departments){
					
					
					if(item.value.toUpperCase() === p_record[0].department.toUpperCase()){
						dept_id = item.id;
						//setFormValues({...formValues, toUser: p_record[0].empId, toUserName: p_record[0].lastName + ', ' + p_record[0].firstName});
						console.log('SET RECORD', p_record[0]);
						let theBu = 'HEDCOR, INC. - BENGUET'
						const tempData = await sendGetRequest(`/${table}/tempcode/${theBu}`);
						if(tempData.data){
							console.log("DEPT FOUND 1", item);
							for(const item1 of tempData.data){
								console.log("DEPT FOUND 2", item1);
								setFormValues({...formValues, businessUnit: theBu,
															docNo:item1.tempCode, fromUserName:item1.empName, 
															toUser: p_record[0].empId, 
															toUserName: p_record[0].lastName + ', ' + p_record[0].firstName, 
															department: '' + dept_id.toString(),
															docNo:item1.tempCode,
															fromUser: context.userInfo.empIdMaster.toString()
											}); 
											
							}
						}
						
					}

				}
				//setFormValues({...formValues, toUser: p_record[0].empId, toUserName: p_record[0].lastName + ', ' + p_record[0].firstName, department: dept_id});
				
			}
		}

		if( p_type === 'Group' ){
			const tempItems = [];
			let ctr = 0;
			
			for(const item of p_record){
				ctr++;
				tempItems.push({toUser: item.id})
			}
			if(ctr > 1){
				setFormValues({...formValues, toUser: JSON.stringify(tempItems), toUserName: 'Multiple Owners', groupName: p_group || ''})
			}else{
				setFormValues({...formValues, toUser: p_record[0].empId, toUserName: p_record[0].fullName})
			}
		}
		
		
	}

	const setValueAssets = (p_records) =>{
		
		const temp_rows = JSON.parse(JSON.stringify(rows));

		for(const record of p_records){
			console.log(record);
			let insert = true;
		
			for(const citem of rows){
				if(citem.assetCode === record.assetTag){
					console.log("matched");
					insert = false;
				}
			}	
        
			if(insert === true){
				temp_rows.push(
					{ 	
						id: genKey()
						, lineIdMaster: record.lineIdMaster || 0
						, quantity: 1
						, serialNo: record.serialNo
						, assetCode: record.assetTag
						, category: ' '
						, assetDesc: record.assetDesc
						, acqCost: record.acqCost
						, totalPrice: 1 * record.acqCost
						, status: record.status || 'active'
						, masterListId: record.masterListId 
					}
				);
			}
			
		}
		setRows(temp_rows);
	}

	const handleCloseUpload = () =>{

		setOpenDialogUpload(false);

	}


	const fileUpload = (e) => {
		const data = new FormData() ;
		data.append('file', e.target.files[0]);
		data.append('id_master', formValues.idMaster);
		sendPostRequest(`/upload/famasupload`, data).then((res) => {
			if(res.error){
				alert("Encountered an error while uploading your file. Please try again.");
			}else{
				alert("Successfully uploaded file.")
			}
		});
	}

	const getUploadItems = async () =>{
		const data = [];
		const tempData = await sendGetRequest(`/upload/${params.id}`);
		
		if(tempData.data){
			for(const item of tempData.data){
				data.push({
					idMaster: item.idMaster,
					headerId: item.headerId,
					fileName: item.fileName,
					filePath: item.filePath
				})
			}
			setFileUploads(data);
		}

	}

	const downloadFile = async (p_item) =>{
		const data = [];
		const tempData = await sendDownloadRequest(`/upload/famasdownload/${p_item.idMaster}`);
		console.log("FILES", tempData);
	}

	const getPermaCode = async (bu) =>{
		const permaData = await sendGetRequest(`/${table}/permacode/${bu}`);
	
		if(permaData.data){
			for(const item of permaData.data){
				setFormValues({...formValues, docNo:item.permaCode});
				console.log(permaData.data);
			}
			
		}

	}

	const handleOpenCloseRoute = (p_value) =>{
		let id;

		if(params.id){
			if(params.id.toString().toUpperCase()==='CREATE'){
				id = formValues.idMaster;		
			}else{
				id = params.id;
			}
		}

		if(p_value === 'route' && buttonLabel === 'route for approval'){

			if(formValues.toUser.toLowerCase() === 'multiple owners' &&  _.isEmpty(selectedTl)){
				alert("An approver is required for a FAMAS document with multiple owners. Please pick one in the Drop Down list. Thank you.")
				return;
			}

			setRequesting(true);

	        getPermaCode(formValues.businessUnit);
			console.log("ROUTE FOR APPROVAL");
			
			console.log(selectedTl);



			const postData = {
				//idMaster: formValues.idMaster, 
				tl: selectedTl,
				remarks: formValues.remarks
			}
	
			sendPutRequest(`/${table}/route/${id}`, postData).then((res) => {
					setRequesting(false);
					if (res.error) {
						setSuccess(false);
						let msg = res.error.response.data.message;
						setStatus(msg);
						alert(msg);
						return;
					}
					
					if(res.data){
						setSuccess(true);
						setStatus(null);
						setFormValues({...formValues, approvalStatus: 'For TL Approval', docNo: res.data[0].docNo});
						setFooterDetails({...footerDetails, approval_status: 'For TL Approval'});
						setButtonLabel('approver');
						alert("FAMAS ROUTED FOR APPROVAL");
					}

					
			});
			
        }

		if(p_value === 'route' && buttonLabel === 'approve'){
           
			setRequesting(true);
	
			const postData = {
				//idMaster: formValues.idMaster, 
				remarks: formValues.remarks
			}

			if(formValues.initApprv === context.userInfo.user.toString() && formValues.approvalStatus === 'For TL Approval'){
				sendPutRequest(`/${table}/approval/${id}`, postData).then((res) => {
					setRequesting(false);
					if (res.error) {
						setSuccess(false);
						let msg = res.error.response.data.message ? res.error.response.data.message : res.error.message;
						setStatus(msg);
						alert(msg);
						return;
					}
					
					if(res.data){
						setSuccess(true);
						setStatus(null);
						setFooterDetails({...footerDetails, approver: false, approva_status: 'Approved'});
						setFormValues({ ...formValues, approvalStatus: 'Approved' });
						
						alert("FAMAS APPROVED");
					}
					
					
					//closeModal ? closeModal(res.data[0].idMaster) : setSuccess(true);
				});
			}else{
				setRequesting(false);
				alert("Action not allowed for this Document.");
			}
	
			
		}

		if(p_value === 'return'  && buttonLabel === 'route for approval'){
           
			setRequesting(true);
			console.log("ROUTE FOR APPROVAL");
			console.log(selectedTl);
			const postData = {
				tl: selectedTl,
				remarks: formValues.remarks
			}
	
			sendPutRequest(`/${table}/return/${id}`, postData).then((res) => {
					setRequesting(false);
					if (res.error) {
						setSuccess(false);
						let msg = res.error.response.data.message ? res.error.response.data.message : res.error.message;
						setStatus(msg);
						alert(msg);
						return;
					}
					if(res.data){
						setSuccess(true);
						setStatus(null);
						setFormValues({ ...formValues, approvalStatus: 'Returned' });
						alert("FAMAS DOC IS RETURNED");
					}
					
					//setFormValues({ ...formValues, idMaster: res.data[0].idMaster });
					//closeModal ? closeModal(res.data[0].idMaster) : setSuccess(true);
			});
		}

		if(p_value === 'return'  && buttonLabel === 'approve'){
           
			setRequesting(true);
	
			const postData = {
				//idMaster: formValues.idMaster, 
				remarks: formValues.remarks
			}
	
			sendPutRequest(`/${table}/return/${id}`, postData).then((res) => {
					setRequesting(false);
					if (res.error) {
						setSuccess(false);
						let msg = res.error.response.data.message ? res.error.response.data.message : res.error.message;
						setStatus(msg);
						alert(msg);
						return;
					}
					setSuccess(true);
					setStatus(null);
					alert("FAMAS DOC IS RETURNED");
					//setFormValues({ ...formValues, idMaster: res.data[0].idMaster });
					//closeModal ? closeModal(res.data[0].idMaster) : setSuccess(true);
			});
		}

		setOpenDialogRoute(false);
	}


	const getRemarks = async () =>{
		const data = [];
		const theStat = '';
		let id;

		if(params.id){
			if(params.id.toString().toUpperCase()==='CREATE'){
				id = formValues.idMaster;		
			}else{
				id = params.id;
			}
		}

		const tempData = await sendGetRequest(`/${table}/remarks/${id}`);
		if(tempData.data){
			for(const item of tempData.data){

                 if(item.returned == true){
					data.push({
						routingRemarks: item.routingRemarks,
						initRemarks: item.initRemarks,
						finRemarks: item.finRemarks,
						mmdRemarks: item.mmdRemarks,
						approvalStatus:  item.approvalStatus + ': ' +  item.returnRemarks + 
						' By: ' + item.returnedBy + ' At: ' + item.returnedDate ,
						initApprv: item.initApprv,
						finApprv: item.finApprv,
						mmdApprv: item.mmdApprv,
						initdate: item.apprvDate1,
						findate: item.apprvDate2,
						mmddate: item.apprvDate,
						updateby: item.updatedBy,
						updatedate: item.updatedDate,
						createby: item.createdBy,
						createddate: item.createdDate,
						returnedremarks: item.returnRemarks,
						returnedby: item.returnedBy,
						returneddate: item.returnedDate,	
					})
					  
				 } else{
					data.push({
						routingRemarks: item.routingRemarks,
						initRemarks: item.initRemarks,
						finRemarks: item.finRemarks,
						mmdRemarks: item.mmdRemarks,
						approvalStatus: item.approvalStatus,
						initApprv: item.initApprv,
						finApprv: item.finApprv,
						mmdApprv: item.mmdApprv,
						initdate: item.apprvDate1,
						findate: item.apprvDate2,
						mmddate: item.apprvDate,
						updateby: item.updatedBy,
						updatedate: item.updatedDate,
						createby: item.createdBy,
						createddate: item.createdDate,
						returnedremarks: item.returnRemarks,
						returnedby: item.returnedBy,
						returneddate: item.returnedDate,
					})
				 }

				
			}
			setRemarks(data);
			
		}

	}

	const handleChangeForAdmin = (event, p_key) => {
		
		if(context.userInfo.role === 'Admin' && (action==='create' || action==='edit')){
			
			let totalPrice = selectedRow.totalPrice;

			if(p_key === 'quantity'){
				totalPrice = selectedRow.acqCost * event.target.value;
			}

			setSelectedRow({...selectedRow, [p_key]: event.target.value, totalPrice});
		}

	}

	const acknowledgeReceiptOfItems = async()=>{
		const postData = {
			header_id: params.id,
			remarks: genericRemarks,
			action: 'Acnowledged Receipt'
		}

		sendPutRequest(`/${table}/receiver/action`, postData).then((res) => {
			
			if (res.error) {
				setSuccess(false);
				setStatus(res.error.message);
				return;
			}

			setSuccess(true);
			setStatus(null);
			alert('Acknowledgement of receipt has been recorded successfully.');

		});
		setOpenReceiverDialog(false);
	}
 
	const checkReceiver = () =>{

		for(const item of receiverAction){
			if(item.actionBy === context.userInfo.empId && item.action === ''){
				setRequireAcknowledgement(true);
			}
		}
		setOpenReceiverDialog(true);
	}

	const test = (event) =>{
		const postData = {
			//idMaster: formValues.idMaster, 
			remarks: 'Test'
		}
		sendPutRequest(`/${table}/receiveroute/38`, postData).then((res) => {
			
			if (res.error) {
				setSuccess(false);
				setStatus(res.error.message);
				return;
			}

		});

	}

	const routeForApprovalOrApprove = (e) =>{
		// setOpenDialogRoute(true); getRemarks();
		if(buttonLabel.toLowerCase()==='approver'){
			alert('No action needed at this moment.');
		}else{
			setOpenDialogRoute(true);
			getTlsList();
		}
		
	}

	const getTlsList = async (e) =>{
        if(_.isEmpty(tls)){
			let table = 'employees/tls'
            let res = await sendGetRequest(table);

            console.log("SEARCH RESULTS", res.data);
            const items = [];

            if(res.data){
                for(const item of res.data){

                    if(item.empId && item.fullname){
                        items.push({id: item.empId, fullName: item.fullname});
                    }
                }
            }
            setTls(items);
        }
    }


	return (
	<Content>
		<div>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
				onClick={handleClick}
			>
				<MoreVertIcon />
			</IconButton>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
			
			>
				
				<span style={{'fontSize':'2.0vh'}}>FAMAS:{ params.id ? `#${params.id}` : `${action}` }</span>
			</IconButton>
			
			<Menu
				id="long-menu"
				anchorEl={anchorEl}
				keepMounted
				open={open}
				onClose={handleClose}
				PaperProps={{
				style: {
					maxHeight: ITEM_HEIGHT * options.length,
					width: '25ch',
				},
				}}
			>
				{options.map((option) => (
				<MenuItem key={option}  onClick={(e)=>handleClose(e, option)}>
					
					<ListItemIcon>
						<ChevronRightTwoToneIcon fontSize="small"/>
					</ListItemIcon>
					<ListItemText primary={option} />	
					
				</MenuItem>
				))}
			</Menu>
		</div>


		<form className={classes.form} onSubmit={onSubmit}>
		
			<Blocker open={requesting} />
			{!closeModal && success && (<Redirect to={{ pathname: `${formValues.idMaster}` }} />)}

			{success === false && <ErrorAlert>Failed: {status}</ErrorAlert>}

			<Grid
				container
				direction="column"
				justifyContent="flex-start"
				alignItems="center"
				spacing={1}
			>
				<Grid item md={12}>
					<Typography variant="h5" component="h5">
						FIXED ASSETS MOVEMENT
					</Typography>
				</Grid>
				<Grid item md={12}>
					<Typography variant="h5" component="h5">
						AND ACCOUNTABILITY SHEET
					</Typography>
				</Grid>
				
			</Grid>
			
			<Accordion  defaultExpanded>
			<AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordion}>HEADER DETAILS:</AccordionSummary>
			<AccordionDetails>
			<Grid
				container
				
				spacing={3}
			> 
				<Grid item  xs={12} md={4}>
					{/* <PickList disabled = {disabledForm} label="TO (Recipient)*" name="assignee" limit = 'multiple' value={formValues.toUserName || ''} readOnly = { false } columns = { columnsEmployees } table={'employees'} setValue = {setValue} capturedItems = {capturedNames}/> */}
					<PickListV2 disabled = {disabledForm} 
							filterField =  "businessUnit" 
							filterItems = { buItems } 
							label="TO (Recipient)*" 
							name="assignee" 
							limit = 'multiple' 
							inputType = 'button' 
							value={formValues.toUserName || ''} 
							readOnly = { false }  
							columns = { columnsEmployees } 
							table={'employees'} 
							setValue = { setValue } 
							columns2 = { personGroupColumns }
							error = {!!formErrors.toUserName || false}
							errorMessage = {formErrors.toUserName}
					/>
				</Grid>


				<Grid item md={4}></Grid>


				<Grid item xs={12} md={4}>
					<FormControl fullWidth variant="outlined">
						<InputLabel htmlFor="docNo">Document Number</InputLabel>
						<OutlinedInput
							id="docNo"
							value={formValues.docNo || ''}
							onChange={handleChange}
							
							labelWidth={150}
							inputProps={{
								disabled: {disabledForm}
							}}
							label="Document Number"
							
						/>
					</FormControl>
				</Grid>

				<Grid item  xs={12} md={4}>
					<FormControl variant="outlined" fullWidth>
						<InputLabel htmlFor="businessUnit">Business Unit</InputLabel>
						<Select
						error={!!formErrors.businessUnit || false}
						disabled = {disabledForm}
						native
						value={ formValues.businessUnit || 0}
						onChange={(e)=>handleChangeBU(e)}
						label="Business Unit"
						inputProps={{
							name: 'businessUnit',
							id: 'businessUnit',
						}}
						>
							<option value={ 0 } disabled hidden>Choose here</option>
							{
								businessUnit && businessUnit.map((item, index)=><option key={`dept_${item.id}_${index}`} value={item.id}>{item.value}</option>)
							}
						</Select>
						{formErrors.businessUnit && <FormHelperText>{formErrors.businessUnit}</FormHelperText>}
					
					</FormControl>
				
				</Grid>
				<Grid item md={4}></Grid>
				<Grid item  xs={12} md={4}>
					
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
							<KeyboardDatePicker
							inputVariant="outlined"
							name="docCreateDate"
							fullWidth
							id="date-picker-dialog"
							label="Date"
							format="MM/dd/yyyy"
							value={formValues.docCreateDate}
							onChange={(e)=>handleDateChange(e)}
							disabled = {disabledForm}
							KeyboardButtonProps={{
								'aria-label': 'change date',
							}}
							/>
						
						
					</MuiPickersUtilsProvider>
				</Grid>
				<Grid item   xs={12} md={4}>
					<FormControl variant="outlined" className={classes.formControl} fullWidth>
						<InputLabel htmlFor="department">Department</InputLabel>
						<Select
						disabled = {disabledForm}
						error={!!formErrors.department || false}
						native
						value={ formValues.department || 0}
						onChange={(e)=>handleChange(e)}
						label="Department"
						inputProps={{
							name: 'department',
							id: 'department',
						}}
						
						>
							<option value = {0} disabled hidden>Choose here</option>
							{
								departments && departments.map((item, index)=><option key={`dept_${item.id}_${index}`} value={item.id}>{item.value}</option>)
							}
						</Select>
						{formErrors.department && <FormHelperText>{formErrors.department}</FormHelperText>}
					</FormControl>
				
				</Grid>

				<Grid item  xs={12} md={4}></Grid>
				
				<Grid item  xs={12} md={4}>
					<TextField
						name="from"
						label="From"
						variant="outlined"
						fullWidth
						value={formValues.fromUserName || ''}
						onChange={handleChange}
						helperText={''}
						error={false}
						required
						disabled = {disabledForm}
					/>
				</Grid>
				
				
				
				<Grid item  xs={12}  md= {4}>
					<FormControl variant="outlined" className={classes.formControl} fullWidth>
						<InputLabel htmlFor="plantSite">Plant / Site</InputLabel>
						<Select
						disabled = {disabledForm}
						native
						value={formValues.plantSite || ' '}
						onChange={(e)=>handleChange(e)}
						label="Plant / Site"
						inputProps={{
							name: 'plantSite',
							id: 'plantSite',
						}}
						>
							<option value=' ' disabled hidden>Choose here</option>
							{
								plantSite && plantSite.map((item, index)=><option key={`plantsite_${item.id}_${index}`} value={item.id}>{item.value}</option>)
							}
						</Select>

					</FormControl>
				</Grid>
				<Grid item  xs={12}  md= {4}>
					<FormControl variant="outlined" className={classes.formControl} fullWidth>
						<InputLabel htmlFor="buildingStructure">Building / Structure</InputLabel>
						<Select
						disabled = {disabledForm}
						native
						value={formValues.buildingStructure || ' '}
						onChange={(e)=>handleChange(e)}
						label="Building / Structure"
						inputProps={{
							name: 'buildingStructure',
							id: 'buildingStructure',
						}}
						>
							<option value=' ' disabled hidden>Choose here</option>
							{
								buildingStructure && buildingStructure.map((item, index)=><option key={`bldg_${item.id}_${index}`} value={item.id}>{item.value}</option>)
							}
						</Select>

					</FormControl>
				</Grid>
				<Grid item  xs={12} md= {4}>
					<FormControl variant="outlined" className={classes.formControl} fullWidth>
						<InputLabel htmlFor="room">Room</InputLabel>
						<Select
						disabled = {disabledForm}
						native
						value={formValues.room || ' '}
						onChange={(e)=>handleChange(e)}
						label="Room"
						inputProps={{
							name: 'room',
							id: 'room',
						}}
						>
							<option value=' ' disabled hidden>Choose here</option>
							{
								room && room.map((item, index)=><option key={`room_${item.id}_${index}`} value={item.id}>{item.value}</option>)
							}
						</Select>

					</FormControl>
				</Grid>

				
				

			</Grid>
			</AccordionDetails>
			</Accordion>

			<Divider style={{"marginTop":"15px","marginBottom":"15px"}}/>
			
			<Grid>
				<Grid item xs={12}> 
					
					<Typography noWrap className={classes.title} gutterBottom>
					<span style={{"color": "blue"}}>Document Approval Status:</span> <span style={{"color": "red"}}>{footerDetails.approval_status}</span>
					</Typography>
			
				</Grid>
			</Grid>

			<Divider style={{"marginTop":"15px","marginBottom":"15px"}}/>

			<Grid
				container
				
				spacing={3}
			>
				
				<Grid item  xs={12} md={4}>
					<FormControl variant="outlined" className={classes.formControl} fullWidth>
						<InputLabel htmlFor="searchCriteria">Action:</InputLabel>
						<Select
						error={!!formErrors.action || false}
						disabled = {disabledForm}
						native
						name = 'selectValue'
						value={formValues.action || ''}
						onChange={(e)=>handleChangeAction(e)}
						label="Action:"
						inputProps={{
							name: 'searchCriteria',
							id: 'searchCriteria',
						}}
						>
							<option aria-label="None" value="" />
							<option value={'transferred'}>Transferred to your end</option>
							<option value={'pulled'}>Pulled out from</option>
							<option value={'cannibalized'}>Cannibalized from</option>
							<option value={'sold'}>Sold per Inv/.OR#</option>
							<option value={'retired'}>Retired</option>
							<option value={'lost'}>Lost</option>
							<option value={'donated'}>Donated</option>
							<option value={'other'}>Other</option>
						</Select>
						{formErrors.action && <FormHelperText>{formErrors.action}</FormHelperText>}
					</FormControl>
				</Grid>
				
				<Grid item  xs={12} md={3}>
					<PickList disabled = {disabledForm} label="Get assets" name="assets" limit = 'multiple' inputType = 'button' value={formValues.assets || ''} readOnly = { false } columns = { columnsSearchFamasItems } table={'famas/header/assignedassets'} setValue = {setValueAssets} />

					
				</Grid>
				<Grid item  xs={12} md={3}>
					<SimplePickList disabled = {disabledForm} filterField =  "businessUnit" filterItems = { buItems } label="Get unassgined assets" name="assets" limit = 'multiple' inputType = 'button' value={formValues.assets || ''} readOnly = { false } columns = { columnsSearchFamasItems } table={'masterlist/unassigned/assets'} setValue = {setValueAssets} />
				</Grid>

				{/* <Grid item  xs={12} md={3}>
					<PickListV2 disabled = {disabledForm} filterField =  "businessUnit" filterItems = { buItems } label="Get unassgined assets" name="assets" limit = 'multiple' inputType = 'button' value={formValues.assets || ''} readOnly = { false }  columns = { columnsSearchFamasItems } table={'masterlist/unassigned/assets'} setValue = {setValue} columns2 = { personGroupColumns }/>
				</Grid> */}
							

			</Grid>
			 
			<Grid
				container
				spacing={3}
			>
				<Grid item  xs={12} md={12}>
					<div style={{ height: 500, width: '100%' }}>
						<DataGrid
							rows={rows}
							
							columns={columns}
							pageSize={10}
							rowsPerPageOptions = {[5, 10, 50]} 
							
							disableSelectionOnClick
							onSelectionModelChange = {handleRowSelection}
						/>
						
					</div>
					
				</Grid>
				
				
				<Grid item container justify="flex-end">
					
					<TextField
						inputProps={{min: 0, style: { textAlign: 'right' }}}
						name="overallTotal"
						label="Total"
						variant="outlined"
						value={total.toLocaleString() || ''}
					/>
				</Grid>
			</Grid>
			<Divider style={{"marginTop":"15px","marginBottom":"15px"}}/>
			<Grid
				container
				spacing={1}
			>
				<Grid item md={12}>
						The recipient of the item/s acknowledges that:
				</Grid>
				<Grid item md={1}></Grid>
				<Grid item md={11}>
						a) the item/s listed were received in good condition.
				</Grid>
				<Grid item md={1}></Grid>
				<Grid item md={11}>
						b) he/she shal be accountable for the loss of or any damage to the item/s through negligence with the amount corresponding to such accountability may be deducted from his/her salary.
				</Grid>
				<Grid item md={1}></Grid>
				<Grid item md={11}>
						c) the asssets issued are to be turned-over to the company upon separation (resignation, termination and / or retirement from the company).
				</Grid>
			</Grid>
			
			
			
			<Grid 
				container
				direction="row"
				justifyContent="center"
				alignItems="flex-start"
				spacing={3}
			>
				<Grid item xs={12} md={12}>
					<Button
						variant="contained"
						color="primary"
						size="large"
						className={classes.button}
						startIcon={<SaveIcon />}
						disabled = {disabledForm}
						onClick = {(e)=>onSubmit(e)}
					>
						Save 
					</Button>
				</Grid>
				{/* <Grid item xs={12} md={3}>
				{
						formValues.idMaster && formValues.idMaster !=='0' ? 
						<Button
						variant="contained"
						color="primary"
						size="large"
						className={classes.button}
						startIcon={<LabelImportantIcon />}
						disabled = {disabledForm}
						onClick = {()=>{setOpenDialogRoute(true); getRemarks(); setButtonLabel("route for approval");}}
						>
							Route 
						</Button> :
						null
				}		
				</Grid> */}
				{/* <Grid item xs={12} md={3}>
				{
						formValues.idMaster && parseInt(formValues.idMaster) > 0 && footerDetails.approver === true ? 
						<Button
						variant="contained"
						color="primary"
						size="large"
						className={classes.button}
						startIcon={<ThumbUpAltIcon />}
						
						onClick = {(e)=>{ routeForApprovalOrApprove(e) }}
						>
							{buttonLabel}
						</Button>
						: 
						null
				}
				</Grid> */}
				{/* <Grid item xs={12} md={3}>
				{
						formValues.idMaster && parseInt(formValues.idMaster) > 0 ? 
						<Button
							variant="contained"
							color="primary"
							size="large"
							className={classes.button}
							startIcon={<PostAddIcon />}
							disabled = {disabledForm}
							onClick = { ()=> { setOpenDialogUpload(true); getUploadItems(); }}
						>
							Attachments
						</Button>
						: 
						null
				}
				</Grid> */}
			</Grid>
			
			<Grid
				container
				spacing={3}
			>
				<Grid item xs={12} md={3}>
					<Card  variant="outlined" style={{"height":"9vw","display":"flex", "flexDirection":"column"}}>
						<CardContent style={{"overflow":"auto"}}>
							<Typography noWrap className={classes.title} color="textSecondary" gutterBottom>
								{footerDetails.from}
							</Typography>
						</CardContent>
						<CardActions style={{"marginTop":"auto"}}>
							<Button size="small">Issued by</Button>
						</CardActions>
					</Card>
				</Grid>
				<Grid item xs={12} md={3}>
					
					<Card  variant="outlined" style={{"height":"9vw","display":"flex", "flexDirection":"column"}}>
						<CardContent style={{"overflow":"auto"}}>
							<Typography noWrap className={classes.title} color="textSecondary" gutterBottom>
								{footerDetails.department}
							</Typography>
						</CardContent>
						<CardActions style={{"marginTop":"auto"}}>
							<Button size="small">Department / Location</Button>
						</CardActions>
					</Card>
				
				</Grid>
				<Grid item xs={12} md={3}>
					<Card  variant="outlined" style={{"height":"9vw","display":"flex", "flexDirection":"column"}}>
						<CardContent style={{"overflow":"auto"}}>
							<Typography noWrap className={classes.title} color="textSecondary" gutterBottom>
								{footerDetails.tl_approver}
							</Typography>
						</CardContent>
						<CardActions style={{"marginTop":"auto"}}>
							<Button size="small" onClick={(e)=>{routeForApprovalOrApprove(e)}}>{buttonLabel}</Button>
						</CardActions>
					</Card>
					
				</Grid>
				
				<Grid item xs={12} md={3}>
					<Card  variant="outlined" style={{"height":"9vw","display":"flex", "flexDirection":"column"}}>
						<CardContent style={{"overflow":"auto"}}>
							
								<Typography className={classes.title} color="textSecondary" gutterBottom>
									{footerDetails.to} 
								</Typography>
							
						</CardContent>
						<CardActions style={{"marginTop":"auto"}}>
							<Button size="small" onClick={(e)=>checkReceiver(e)} >Received by</Button>
						</CardActions>
					</Card>
					
				</Grid>
			</Grid>
		</form>



		<Dialog
			open={openDialog}
			onClose={handleClose}
			scroll={'paper'}
			aria-labelledby="scroll-dialog-title"
			aria-describedby="scroll-dialog-description"
			fullWidth = {true}
			maxWidth = {'sm'}
		>
			<DialogTitle id="scroll-dialog-title">Asset Details</DialogTitle>
			<DialogContent dividers={true}>
			<DialogContentText
				id="scroll-dialog-description"
				tabIndex={-1}
			>
				<Grid 
					container
					spacing={3}
				>
					<Grid item xs={12} md={12}>
						<FormControl fullWidth variant="outlined">
						<InputLabel htmlFor="selectedItemQuantity">Quantity</InputLabel>
						<OutlinedInput
							id="selectedItemQuantity"
							value={selectedRow.quantity}
							onChange={(e)=>{handleChangeForAdmin(e, 'quantity')}}
							fullWidth
							variant="outlined"
							label="Quantity"
							name="quantity"
						/>
						</FormControl>
						
					</Grid>
					<Grid item xs={12} md={12}>
						<TextField
							id="selectedItemAssetTag"
							label="Asset Tag"
							value = {selectedRow.assetCode || ''}
							variant="outlined"
							fullWidth
						/>
					</Grid>
					<Grid item xs={12} md={12}>
						<TextField
							id="selectedItemSerialNo"
							label="Serial Number"
							value = {selectedRow.serialNo || ''}
							variant="outlined"
							fullWidth
						/>
					</Grid>
					<Grid item xs={12} md={12}>
						<TextField
							id="selectedItemAssetDescription"
							multiline
							rows={6}
							label="Asset Description"
							value = {selectedRow.assetDesc || ''}
							variant="outlined"
							name = 'assetDesc'
							onChange = {(e)=> handleChangeForAdmin(e,'assetDesc')}
							fullWidth
						/>
					</Grid>
					<Grid item xs={12} md={12}>
						<TextField
							id="selectedItemAcquisitionCost"
							label="Acquisition Cost"
							value = {selectedRow.acqCost || 0}
							variant="outlined"
							fullWidth
						/>
					</Grid>
					
					<Grid item xs={12} md={12}>
						<TextField
							id="selectedItemTotalCost"
							label="Total Price"
							value = {selectedRow.totalPrice || 0}
							variant="outlined"
							fullWidth
						/>
					</Grid>
				</Grid>
			</DialogContentText>
			</DialogContent>
			<DialogActions>
			<Button onClick={()=>handleCloseDialog('cancel')} color="primary">
				Close
			</Button>
			<Button onClick={()=>handleCloseDialog('cancel')} color="primary">
				Acknowledge
			</Button>
			{
				action === 'edit' || action === 'create' ? 
				<React.Fragment>
					<Button onClick={()=>handleCloseDialog('update')} color="primary">
						Update
					</Button>
					<Button onClick={()=>handleCloseDialog('remove')} color="primary">
						Remove
					</Button>
				</React.Fragment>
				:
				null
			}
			</DialogActions>
		</Dialog>


		<Dialog
			open={openReceiverDialog}
			onClose={handleClose}
			scroll={'paper'}
			aria-labelledby="receiverDialogTitle"
			aria-describedby="receiverDialogDescription"
			fullWidth = {true}
			maxWidth = {'sm'}
		>
			<DialogTitle id="receiverDialogTitle">Receipt Details</DialogTitle>
			<DialogContent dividers={true}>
			<DialogContentText
				id="receiverDialogDescription"
				tabIndex={-1}
			>
				<Grid 
					container
					spacing={3}
				>
					<Grid item xs={12} md={12}>
						<List>
							{
								receiverAction.map((item)=>
									<ListItem alignItems="flex-start">
								
									<ListItemText
									primary={item.firstName + ' ' + item.lastName}
									secondary={
										<React.Fragment>
										<Typography
											component="span"
											variant="body2"
											className={classes.inline}
											color="textPrimary"
										>
											Acknowledgement Receipt: {item.actionDate}
										</Typography>
										{item.remarks}
										</React.Fragment>
									}
									/>
									<Divider variant="inset" component="li" />
									</ListItem>
								)
							}
						
						
						
						</List>
						
					</Grid>

					{
						requireAcknowledgement ?
						<Grid item xs={12} md={12}>
							<TextField
								label="Remarks"
								multiline
								rows={7}
								variant="outlined"
								name="remarks"
								fullWidth
								value={ genericRemarks }
								onChange={(e)=>{setGenericRemarks(e.target.value)}}
							/>
						</Grid> : null
					}
					
					
				</Grid>
			</DialogContentText>
			</DialogContent>
			<DialogActions>
			<Button onClick={()=>setOpenReceiverDialog(false)} color="primary">
				Close
			</Button>
			{
				requireAcknowledgement ? 
				<Button onClick={()=>acknowledgeReceiptOfItems()} color="primary">
					Acknowledge Receipt of item(s)
				</Button>
				: null
			}
			
			
			
			</DialogActions>
		</Dialog>


		<Dialog
			open = { openDialogUpload }
			onClose = { handleCloseUpload }
			scroll = {'paper'}
			aria-labelledby = "scroll-dialog-title"
			aria-describedby = "scroll-dialog-description"
			fullWidth = { true }
			maxWidth = { 'sm' }
		>
			<DialogTitle id="scroll-dialog-title1">Attachment(s)</DialogTitle>
			<DialogContent dividers={true}>
			<DialogContentText
				id="scroll-dialog-title1"
				tabIndex={-1}
			>
				<Grid 
					container
					spacing={3}
				>
					<Grid item xs={12} md={12} align="center">
						<img
							src={headerImage}
							alt="uploadImage"
							style={{
								overflow: 'hidden',
								Width: '100%',
								maxHeight: '200px',
								marginTop: '0.1em',
							}}
						/>
					</Grid>
					<Grid item xs={12} md={12} align="center">
						<Button
							variant="contained"
							component="label"
						>
						Upload File
						<input
							type="file"
							hidden
							onChange = {(e) => fileUpload(e)}
						/>
						</Button>	
					</Grid>
					<Grid item xs={12} md={12}>
							<List dense={true}>
							{
								fileUploads.map((item)=>
										
										<ListItem key={genKey()}>
											<ListItemAvatar>
												<Avatar>
												<FolderIcon />
												</Avatar>
											</ListItemAvatar>
											<ListItemText
												className = {classes.link}
												primary={item.fileName}
												secondary={true}
												onClick = {()=> downloadFile(item)}
											/>
											<ListItemSecondaryAction>
												<IconButton edge="end" aria-label="delete">
												<DeleteIcon />
												</IconButton>
											</ListItemSecondaryAction>
										</ListItem>
										
									
								)
							}
							</List>
					</Grid>
					
				</Grid>
			</DialogContentText>
			</DialogContent>
			<DialogActions>
			<Button onClick={()=>handleCloseUpload('cancel')} color="primary">
				Cancel
			</Button>
			{
				action === 'edit' || action === 'create' ? 
				<React.Fragment>
					<Button onClick={()=>handleCloseUpload('update')} color="primary">
						Update
					</Button>
					<Button onClick={()=>handleCloseUpload('remove')} color="primary">
						Remove
					</Button>
				</React.Fragment>
				:
				null
			}
			
			</DialogActions>
		</Dialog>

		<Dialog
			open = { openDialogRoute }
			onClose = { handleOpenCloseRoute }
			scroll = {'paper'}
			aria-labelledby = "scroll-dialog-title"
			aria-describedby = "scroll-dialog-description"
			fullWidth = { true }
			maxWidth = { 'sm' }
		>
			<DialogTitle id="scroll-dialog-title1">Route FAMAS </DialogTitle>
			<DialogContent dividers={true}>
			<DialogContentText
				id="scroll-dialog-title1"
				tabIndex={-1}
			>
				<Grid 
					container
					spacing={3}
				>
					<Grid item xs={12} md={12} align="center">
						<img
							src={headerRoute}
							alt="uploadImage"
							style={{
								overflow: 'hidden',
								Width: '100%',
								maxHeight: '200px',
								marginTop: '0.1em',
							}}
						/>
					</Grid>
					{
						formValues.approvalStatus && formValues.approvalStatus === 'For Approval' ?
						<Grid item ={12} md={12}>
						<Autocomplete
							onChange={(event, value) => {
								if(value){
									setSelectedTl(value);
									//setRecords({...records, toUser: JSON.stringify(items)});
								}
							}} 
							
							id="assignedApprover"
							options={tls}
							value = {selectedTl}
							getOptionLabel={(option) => option.fullName}
							filterSelectedOptions
							
							renderInput={(params) => (
								<TextField
									{...params}
									variant="outlined"
									label="Assignee Group Members"
									placeholder="Assignee Group Members"
								/>
							)}
						/>
						</Grid>:null
					}
					

					<Grid item xs={12} md={12}>
					<TextField
						label="Remarks"
						multiline
						rows={7}
						variant="outlined"
						name="remarks"
						fullWidth
						//value={''}
						onChange={handleChange}
						helperText={formErrors.remarks || ''}
						error={!!formErrors.remarks || false}
						required
						
					/>
					</Grid>
					<Grid item xs={12} md={12}>
						<div> 
							<List dense={true}>
							{
								//replace below with remarks
								remarks.map((item)=>
								        
										<ListItem key={genKey()}>
											<ListItemAvatar>
												<Avatar><RemIcon /></Avatar>
											</ListItemAvatar>
											<ListItemText
												primary={`Approval Status: ${item.approvalStatus}`}
												secondary={true}
											/>
										</ListItem>
								)
							}
							</List>

							<List dense={true}>
							{
								//replace below with remarks
								remarks.map((item)=>
								        
										<ListItem key={genKey()}>
											<ListItemAvatar>
												<Avatar><RemIcon /></Avatar>
											</ListItemAvatar>
											<ListItemText
												primary={`Routing Remarks: ${item.routingRemarks}`}
												secondary={true}
											/>
										</ListItem>
							  )
							}
							</List>

							<List dense={true}>
							{
								//replace below with remarks
								remarks.map((item)=>
								        
										<ListItem key={genKey()}>
											<ListItemAvatar>
												<Avatar><RemIcon /></Avatar>
											</ListItemAvatar>
											<ListItemText
												primary={`TL Approval Remarks: ${item.initRemarks}`}
												secondary={true}
											/>
										</ListItem>
							  )
							}
							</List>

						</div>
					</Grid>
				</Grid>
			</DialogContentText>
			</DialogContent>
			<DialogActions>
			<Button onClick={()=>handleOpenCloseRoute('cancel')} color="primary">
				Cancel
			</Button>
			{
				footerDetails.editable === true || footerDetails.approver ? 
				<React.Fragment>
					<Button onClick={()=>handleOpenCloseRoute('route')} color="primary">
						{buttonLabel}
					</Button>
					<Button onClick={()=>handleOpenCloseRoute('return')} color="primary">
						Return
					</Button>
				</React.Fragment>
				:
				null
			}
			
			</DialogActions>
		</Dialog>	


	</Content>
	);
};

FamasForm.propTypes = formPropTypes;

FamasForm.defaultProps = formDefaultPropValues;

export default FamasForm;
